export default __webpack_public_path__ + "static/media/dashboard_medical_yoga_session_icon.afb2391a.svg";